import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	width: 100%;

	.result-header {
		display: flex;
		place-items: center;
		gap: 0.5em;

		.result-header-icon {
			margin: 0.3em 0 0 0;
		}

		.result-header-title {
			color: ${vars.colorSuccess};
			font-weight: 500;
			font-size: 2em;
		}
	}
	.result-description {
		line-height: 1.8em;
	}

	@media all and (max-width: ${vars.mobileL}) {
		.result-description {
			font-size: 1.2em;
			margin: 1em 0;
		}
	}
`;
